"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _set = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _react = _interopRequireWildcard(require("react"));
var _uiTheme = require("@kyruus/ui-theme");
var _intl = require("@kyruus/intl");
var _propTypes = require("prop-types");
var _gmap = _interopRequireDefault(require("@kyruus/gmap"));
var _awsMap = require("@kyruus/aws-map");
var _button = _interopRequireDefault(require("@kyruus/button"));
var _messages = _interopRequireDefault(require("../../lib/messages"));
var _Locations = _interopRequireDefault(require("./Locations"));
var _styles = require("./styles");
var _ProviderLocations = require("./ProviderLocations.utils");
var gmapUtils = _interopRequireWildcard(require("./ProviderLocations.gmap.utils"));
var awsUtils = _interopRequireWildcard(require("./ProviderLocations.aws.utils"));
var _useWindowWidth = _interopRequireDefault(require("../../lib/useWindowWidth"));
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const propTypes = {
  bookableLocations: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    id: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
    name: _propTypes.string,
    street1: _propTypes.string,
    street2: _propTypes.string,
    suite: _propTypes.string,
    city: _propTypes.string,
    state: _propTypes.string,
    zip: _propTypes.string
  })).isRequired,
  nonBookableLocations: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    id: _propTypes.string,
    name: _propTypes.string,
    street1: _propTypes.string,
    street2: _propTypes.string,
    suite: _propTypes.string,
    city: _propTypes.string,
    state: _propTypes.string,
    zip: _propTypes.string
  })).isRequired,
  /**
   * location on select handler
   * @callback
   * @param {Object} props
   * @param {Set} props.selectedLocationIds all currently selected location ids
   */
  onSelect: _propTypes.func.isRequired,
  /**
   * Injected by `injectIntl HOC`
   */
  intl: (0, _propTypes.shape)({
    locale: _propTypes.string.isRequired,
    formatMessage: _propTypes.func.isRequired
  }).isRequired,
  selectedLocationIds: (0, _propTypes.instanceOf)(_set.default).isRequired,
  highlightedLocId: _propTypes.string,
  url: _propTypes.string,
  config: _propTypes.object.isRequired,
  awsMapConfig: _propTypes.object
};

/**
 * ┌──────────────────────────┐
 * │                          │
 * │            Map           │
 * │                          │
 * ├──────────────────────────┤
 * │ ┌─┐ ┌──────────────────┐ │
 * │ │X│ │     Location     │ │
 * │ └─┘ └──────────────────┘ │
 * ├──────────────────────────┤
 * │ ┌─┐ ┌──────────────────┐ │
 * │ │X│ │    Location      │ │
 * │ └─┘ └──────────────────┘ │
 * ├──────────────────────────┤
 * │     ┌──────────────────┐ │
 * │     │    Location      │ │
 * │     └──────────────────┘ │
 * └──────────────────────────┘
 */
const ProviderLocations = (0, _uiTheme.withTheme)(_ref => {
  var _context;
  let {
    theme,
    bookableLocations,
    nonBookableLocations,
    onSelect,
    intl,
    selectedLocationIds,
    highlightedLocId = null,
    url = '',
    locationId,
    className,
    mapEventsToRegister,
    config,
    awsMapConfig
  } = _ref;
  const {
    aboveMd
  } = (0, _useWindowWidth.default)();
  const [showMap, setShowMap] = (0, _react.useState)(aboveMd);
  const [showToggleMap, setShowToggleMap] = (0, _react.useState)(false);
  const [activeListLocId, setActiveListLocId] = (0, _react.useState)();
  const markersRef = (0, _react.useRef)([]);
  (0, _react.useEffect)(() => {
    setShowToggleMap(!aboveMd);
    if (aboveMd) {
      setShowMap(true);
    }
  }, [aboveMd]);
  (0, _react.useEffect)(() => {
    setActiveListLocId(highlightedLocId);
  }, [highlightedLocId, setActiveListLocId]);
  const handleSelectLocation = id => {
    onSelect((0, _ProviderLocations.toggleLocationInSet)(selectedLocationIds, id), id);
  };

  // Event handlers
  const handleMarkerMouseout = (0, _react.useCallback)(() => {
    setActiveListLocId(null);
  }, [setActiveListLocId]);
  const handleMarkerMouseover = (0, _react.useCallback)(_ref2 => {
    let {
      meta
    } = _ref2;
    setActiveListLocId(meta.location.id);
  }, [setActiveListLocId]);
  const handleGetMarkers = (0, _react.useCallback)(markers => {
    markersRef.current = markers;
    if (config.maps_config?.location_service_provider === 'aws') {
      awsUtils.updateNonBookableMarkers(markers, nonBookableLocations);
    } else {
      gmapUtils.updateNonBookableMarkers(markers, nonBookableLocations, theme);
    }
  }, [markersRef, nonBookableLocations, theme, config]);
  const handleLocationMouseEnter = (0, _react.useCallback)(id => {
    setActiveListLocId(id);

    // https://healthsparq.atlassian.net/browse/KENG-41045
    if (config.maps_config?.location_service_provider === 'aws') {
      awsUtils.animateLocationMarker(markersRef.current, id);
    } else {
      gmapUtils.animateLocationMarker(markersRef.current, id);
    }
  }, [setActiveListLocId, markersRef, config]);
  const handleLocationMouseLeave = (0, _react.useCallback)(() => {
    setActiveListLocId(null);

    // https://healthsparq.atlassian.net/browse/KENG-41045
    if (config.maps_config?.location_service_provider === 'aws') {
      awsUtils.clearMarkerAnimation(markersRef.current);
    } else {
      gmapUtils.clearMarkerAnimation(markersRef.current);
    }
  }, [setActiveListLocId, markersRef, config]);
  const mapLocations = (0, _concat.default)(_context = []).call(_context, bookableLocations, nonBookableLocations);
  return /*#__PURE__*/_react.default.createElement(_styles.Container, {
    "data-testid": "ProviderLocations",
    className: className
  }, /*#__PURE__*/_react.default.createElement(_styles.Header, null, !aboveMd && /*#__PURE__*/_react.default.createElement("h5", null, "Available Locations"), showToggleMap && /*#__PURE__*/_react.default.createElement(_button.default, {
    onClick: () => setShowMap(!showMap),
    mode: "flat"
  }, showMap ? /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.hideMap) : /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.showMap))), /*#__PURE__*/_react.default.createElement(_styles.Body, {
    className: "ProviderLocationsBody"
  }, showMap && /*#__PURE__*/_react.default.createElement(_styles.MapContainer, {
    className: "MapContainer"
  }, config.maps_config?.location_service_provider === 'aws' ? /*#__PURE__*/_react.default.createElement(_awsMap.AwsMap, {
    locations: (0, _map.default)(mapLocations).call(mapLocations, loc => ({
      ...loc,
      isDisabled: !selectedLocationIds.has(loc.id)
    })),
    mapEventsToRegister: mapEventsToRegister,
    awsMapConfig: awsMapConfig,
    getMarkers: handleGetMarkers
  }) : /*#__PURE__*/_react.default.createElement(_gmap.default, {
    "aria-label": intl.formatMessage(_messages.default.ariamapcontainer),
    enabledLocationIds: selectedLocationIds,
    url: url,
    locations: mapLocations,
    getMarkers: handleGetMarkers,
    onMarkerMouseout: handleMarkerMouseout,
    onMarkerMouseover: handleMarkerMouseover,
    mapEventsToRegister: mapEventsToRegister
  })), /*#__PURE__*/_react.default.createElement(_Locations.default, {
    bookableLocations: bookableLocations,
    nonBookableLocations: nonBookableLocations,
    onSelect: handleSelectLocation,
    selectedLocationIds: selectedLocationIds,
    onMouseEnter: handleLocationMouseEnter,
    onMouseLeave: handleLocationMouseLeave,
    activeLocationId: activeListLocId,
    locationId: locationId
  })));
});
ProviderLocations.defaultProps = {
  url: '',
  highlightedLocId: null
};
ProviderLocations.propTypes = propTypes;
var _default = exports.default = (0, _intl.injectIntl)(ProviderLocations);